<template>
  <div class="upload-letter-page">
    <h2>{{ $t('W2P_UPLOAD_MATERIAL_PAGE_TITLE') }}</h2>

    <pn-toast
      v-if="showInvalidatedMaterialMsg"
      icon="alert-exclamation-circle"
      closable
      appearance="warning"
    >
      <p>
        {{
          $t('W2P_INVALIDATED_MATERIAL_MESSAGE', {
            printType: letterOptions.printType,
            max: productDelivery.page_count.origMax
          })
        }}
        <span v-if="letterOptions.includePreface">
          {{
            $t('W2P_INVALIDATED_MATERIAL_PREFACE_NOTE', {
              count: letterOptions.printType === 'single-sided' ? '1' : '2'
            })
          }}
        </span>
      </p>
    </pn-toast>

    <how-to-upload-letter></how-to-upload-letter>
    <upload-material-component
      @materialUploaded="next"
      service="letter"
    ></upload-material-component>

    <div class="button-container">
      <pn-button-container secondary size="medium">
        <button @click="$router.push({ name: 'upload' })">
          {{ $t('W2P_LETTER_BACK') }}
        </button>
      </pn-button-container>

      <pn-button-container size="medium">
        <button :disabled="!valid" @click="next" class="next">
          {{ $t('W2P_LETTER_NEXT') }}
        </button>
      </pn-button-container>
    </div>
  </div>
</template>

<script>
import UploadMaterialComponent from '@/components/UploadMaterialComponent'
import HowToUploadLetter from '@/components/how-to/upload-letter/HowToUploadLetterComponent'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    HowToUploadLetter,
    UploadMaterialComponent
  },
  computed: {
    ...mapState('letter/upload', [
      'valid',
      'showInvalidatedMaterialMsg',
      'letterOptions'
    ]),
    ...mapState('cart', ['productDelivery'])
  },
  beforeDestroy() {
    this.SET_MATERIAL({
      key: 'showInvalidatedMaterialMsg',
      value: false
    })
  },
  methods: {
    ...mapMutations('letter/upload', ['SET_MATERIAL']),
    next() {
      this.$router.push('/letter/upload/preview-letter')
    }
  },
  mounted() {
    sessionStorage.removeItem('orderPlaced')
  }
}
</script>

<style lang="scss" scoped>
pn-toast {
  margin: 1.5em 0;
}
</style>
